export function buildPointsFilters(userId: string, userType: string) {
  const params: Record<string, string> = {};
  if (userId.trim()) params.user_id = userId.trim();
  if (userType) params.user_type = userType;
  return params;
}
